<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="printItem" v-for="(item, index) in data" :key="index">
        <div class="left" :id="'qrCode' + item.workCenterNo"></div>
        <div class="right">
          <div>编号：{{ item.workCenterNo }}</div>
          <div>名称：{{ item.workCenterName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      data: [],
    };
  },

  mounted() {
    this.data = JSON.parse(this.$route.query.params);
    console.log(this.data);
    for (let item of this.data) {
      this.$nextTick(() => {
        document.getElementById("qrCode" + item.workCenterNo).innerHTML = "";
        this.bindQRCode(item.workCenterNo);
      });
    }
  },

  methods: {
    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 100,
        height: 100,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 76mm;
  height: 36mm;
  border: 0.5mm solid #111;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  .left {
    width: 30mm;
    height: 100%;
    border-right: 0.5mm solid #111;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
  }
  .right {
    width: calc(100% - 30mm);
    float: left;
    display: flex;
    flex-direction: column;
    padding: 0 0.5mm;
    height: 100%;
    div {
      flex: auto;
      display: flex;
      align-items: center;
      border-bottom: 0.5mm solid #111;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
